/**
 * MMP Metadata
 * This is a API for MMP Metadata
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: st116848@stud.uni-stuttgart.de.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { Run } from '../model/run';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class RunService {

    protected basePath = 'https://localhost:8080/v1/metadata';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    /**
     * adds an run
     * Adds an run
     * @param experiment The experiemnt\&#39;s id
     * @param run Run item to add
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addRun(experiment: string, run?: Run, observe?: 'body', reportProgress?: boolean): Observable<Run>;
    public addRun(experiment: string, run?: Run, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Run>>;
    public addRun(experiment: string, run?: Run, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Run>>;
    public addRun(experiment: string, run?: Run, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (experiment === null || experiment === undefined) {
            throw new Error('Required parameter experiment was null or undefined when calling addRun.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Run>(`${this.configuration.basePath}/experiments/${encodeURIComponent(String(experiment))}/runs`,
            run,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * run by id
     * Return one run by &#x60;id&#x60;
     * @param run The run\&#39;s id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRunById(run: string, observe?: 'body', reportProgress?: boolean): Observable<Run>;
    public getRunById(run: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Run>>;
    public getRunById(run: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Run>>;
    public getRunById(run: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (run === null || run === undefined) {
            throw new Error('Required parameter run was null or undefined when calling getRunById.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Run>(`${this.configuration.basePath}/experiments/runs/${encodeURIComponent(String(run))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * list of runs
     * Return list of runs
     * @param experiment The experiemnt\&#39;s id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRunsByExperiment(experiment: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Run>>;
    public getRunsByExperiment(experiment: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Run>>>;
    public getRunsByExperiment(experiment: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Run>>>;
    public getRunsByExperiment(experiment: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (experiment === null || experiment === undefined) {
            throw new Error('Required parameter experiment was null or undefined when calling getRunsByExperiment.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Run>>(`${this.configuration.basePath}/experiments/${encodeURIComponent(String(experiment))}/runs`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * update run by id
     * Updates an run
     * @param runId The run\&#39;s id
     * @param run Run item to updated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateRunById(runId: string, run?: Run, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateRunById(runId: string, run?: Run, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateRunById(runId: string, run?: Run, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateRunById(runId: string, run?: Run, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (runId === null || runId === undefined) {
            throw new Error('Required parameter runId was null or undefined when calling updateRunById.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.configuration.basePath}/experiments/runs/${encodeURIComponent(String(runId))}`,
            run,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
